import { createSlice } from '@reduxjs/toolkit';

const INITITAL_STATE = {
  content: null,
  options: null,
  callback: null
};

const modalSlice = createSlice({
  name: 'modal',
  initialState: INITITAL_STATE,
  reducers: {
    open: (state, action) => {
      if (!action.payload.content) return;

      state.content = action.payload.content;
      if (action.payload.options) state.options = action.payload.options;
      if (action.payload.callback) state.callback = action.payload.callback;
    },
    close: (state) => {
      state.content = INITITAL_STATE.content;
      state.options = INITITAL_STATE.options;
      state.callback = INITITAL_STATE.callback;
    }
  }
});

export default modalSlice.reducer;
export const { open, close } = modalSlice.actions;
